import React from "react";
import PropTypes from "prop-types";
import { CurrencyFormat } from "views/helpers/CurrencyFormat";

export default function CardTableNeraca({
  color,
  tableTitle,
  dataAktivaLancar,
  dataAktivaTetap,
  dataKewajibanJangkaPendek,
  dataKewajibanJangkaPanjang,
  dataModal,
  totalAktivaLancar,
  totalAktivaTetap,
  totalAktiva,
  totalKewajibanJangkaPendek,
  totalKewajibanJangkaPanjang,
  totalKewajiban,
  totalModal,
}) {
  return (
    <>
      <div
        className={
          "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded " +
          (color === "light" ? "bg-white" : "bg-lightBlue-900 text-white")
        }
      >
        <div className="rounded-t mb-0 px-4 py-3 border-0">
          <div className="flex flex-wrap items-center">
            <div className="relative w-full px-4 max-w-full flex-grow flex-1">
              <h3
                className={
                  "font-semibold text-lg " +
                  (color === "light" ? "text-blueGray-700" : "text-white")
                }
              >
                {tableTitle ? tableTitle : "Laporan Arus Kas"}
              </h3>
            </div>
            <div></div>
          </div>
        </div>
        <div className="block overflow-x-auto">
          <div className="items-center pb-4">
            <h1 className="text-center text-xl font-bold">Laporan Neraca</h1>
          </div>
        </div>
        <div className="container px-4 mx-auto">
          <div className="flex flex-wrap">
            <div className="w-full px-4 flex-1">
              <h1 className="text-lg font-bold block my-2 p-1 text-blueGray-700 text-left">
                AKTIVA
              </h1>
            </div>
            <div className="w-full px-4 flex-1">
              {/* <span className="text-sm block my-4 p-1 text-blueGray-700 text-right"></span> */}
            </div>
          </div>
          <div className="flex flex-wrap">
            <div className="w-full px-4 flex-1">
              <h1 className="text-base font-bold block my-2 p-1 text-blueGray-700 text-left">
                AKTIVA LANCAR
              </h1>
            </div>
            <div className="w-full px-4 flex-1">
              <span className="text-base font-bold block my-2 p-1 text-blueGray-700 text-right">
                {/* {CurrencyFormat(totalAktivaLancar)} */}
              </span>
            </div>
          </div>
          {dataAktivaLancar.map((aktivaLancar, indexAktivaLancar) => (
            <div key={indexAktivaLancar} className="flex flex-wrap">
              <div className="w-full px-4 flex-1">
                {" "}
                <h1 className="text-base block my-2 p-1 text-blueGray-700 text-left">
                  {aktivaLancar.kode_akun} - {aktivaLancar.nama_akun}
                </h1>
              </div>
              <div className="w-full px-4 flex-1">
                <span className="text-base block my-2 p-1 text-blueGray-700 text-right">
                  {CurrencyFormat(aktivaLancar.jumlah)}
                </span>
              </div>
            </div>
          ))}
          <br />
          <div className="flex flex-wrap">
            <div className="w-full px-4 flex-1">
              <h1 className="text-base font-bold block my-2 p-1 text-blueGray-700 text-left">
                AKTIVA TETAP
              </h1>
            </div>
            <div className="w-full px-4 flex-1">
              <span className="text-base font-bold block my-2 p-1 text-blueGray-700 text-right">
                {/* {CurrencyFormat(totalAktivaTetap)} */}
              </span>
            </div>
          </div>
          {dataAktivaTetap.map((aktivaTetap, indexAktivaTetap) => (
            <div key={indexAktivaTetap} className="flex flex-wrap">
              <div className="w-full px-4 flex-1">
                {" "}
                <h1 className="text-base block my-2 p-1 text-blueGray-700 text-left">
                  {aktivaTetap.kode_akun} - {aktivaTetap.nama_akun}
                </h1>
              </div>
              <div className="w-full px-4 flex-1">
                <span className="text-base block my-2 p-1 text-blueGray-700 text-right">
                  {CurrencyFormat(aktivaTetap.jumlah)}
                </span>
              </div>
            </div>
          ))}
          <br />
          <div className="flex flex-wrap">
            <div className="w-full px-4 flex-1">
              <h1 className="text-base font-bold block my-2 p-1 text-blueGray-700 text-left">
                TOTAL AKTIVA
              </h1>
            </div>
            <u>
              <div className="w-full px-4 flex-1">
                <span className="text-base font-bold block my-2 p-1 text-blueGray-700 text-right">
                  {CurrencyFormat(totalAktiva)}
                </span>
              </div>
            </u>
          </div>
          <br />
          <div className="flex flex-wrap">
            <div className="w-full px-4 flex-1">
              <h1 className="text-lg font-bold block my-2 p-1 text-blueGray-700 text-left">
                HUTANG & MODAL
              </h1>
            </div>
            <div className="w-full px-4 flex-1">
              {/* <span className="text-sm block my-4 p-1 text-blueGray-700 text-right"></span> */}
            </div>
          </div>
          <div className="flex flex-wrap">
            <div className="w-full px-4 flex-1">
              <h1 className="text-base font-bold block my-2 p-1 text-blueGray-700 text-left">
                HUTANG LANCAR
              </h1>
            </div>
            <div className="w-full px-4 flex-1">
              <span className="text-base font-bold block my-2 p-1 text-blueGray-700 text-right">
                {/* {CurrencyFormat(totalKewajibanJangkaPendek)} */}
              </span>
            </div>
          </div>
          {dataKewajibanJangkaPendek.map(
            (kewajibanJangkaPendek, indexKewajibanJangkaPendek) => (
              <div key={indexKewajibanJangkaPendek} className="flex flex-wrap">
                <div className="w-full px-4 flex-1">
                  {" "}
                  <h1 className="text-base block my-2 p-1 text-blueGray-700 text-left">
                    {kewajibanJangkaPendek.kode_akun} -{" "}
                    {kewajibanJangkaPendek.nama_akun}
                  </h1>
                </div>
                <div className="w-full px-4 flex-1">
                  <span className="text-base block my-2 p-1 text-blueGray-700 text-right">
                    {CurrencyFormat(kewajibanJangkaPendek.jumlah)}
                  </span>
                </div>
              </div>
            )
          )}
          <br />
          <div className="flex flex-wrap">
            <div className="w-full px-4 flex-1">
              <h1 className="text-base font-bold block my-2 p-1 text-blueGray-700 text-left">
                HUTANG JANGKA PANJANG
              </h1>
            </div>
            <div className="w-full px-4 flex-1">
              <span className="text-base font-bold block my-2 p-1 text-blueGray-700 text-right">
                {/* {CurrencyFormat(totalKewajibanJangkaPanjang)} */}
              </span>
            </div>
          </div>
          {dataKewajibanJangkaPanjang.map(
            (kewajibanJangkaPanjang, indexKewajibanJangkaPanjang) => (
              <div key={indexKewajibanJangkaPanjang} className="flex flex-wrap">
                <div className="w-full px-4 flex-1">
                  {" "}
                  <h1 className="text-base block my-2 p-1 text-blueGray-700 text-left">
                    {kewajibanJangkaPanjang.kode_akun} -{" "}
                    {kewajibanJangkaPanjang.nama_akun}
                  </h1>
                </div>
                <div className="w-full px-4 flex-1">
                  <span className="text-base block my-2 p-1 text-blueGray-700 text-right">
                    {CurrencyFormat(kewajibanJangkaPanjang.jumlah)}
                  </span>
                </div>
              </div>
            )
          )}
          <br />
          <div className="flex flex-wrap">
            <div className="w-full px-4 flex-1">
              <h1 className="text-base font-bold block my-2 p-1 text-blueGray-700 text-left">
                MODAL
              </h1>
            </div>
            <div className="w-full px-4 flex-1">
              <span className="text-base font-bold block my-2 p-1 text-blueGray-700 text-right">
                {/* {CurrencyFormat(totalModal)} */}
              </span>
            </div>
          </div>
          {dataModal.map((modal, indexModal) => (
            <div key={indexModal} className="flex flex-wrap">
              <div className="w-full px-4 flex-1">
                {" "}
                <h1 className="text-base block my-2 p-1 text-blueGray-700 text-left">
                  {modal.kode_akun} - {modal.nama_akun}
                </h1>
              </div>
              <div className="w-full px-4 flex-1">
                <span className="text-base block my-2 p-1 text-blueGray-700 text-right">
                  {CurrencyFormat(modal.jumlah)}
                </span>
              </div>
            </div>
          ))}
          <br />
          <div className="flex flex-wrap">
            <div className="w-full px-4 flex-1">
              <h1 className="text-base font-bold block my-2 p-1 text-blueGray-700 text-left">
                TOTAL HUTANG & MODAL
              </h1>
            </div>
            <u>
              <div className="w-full px-4 flex-1">
                <span className="text-base font-bold block my-2 p-1 text-blueGray-700 text-right">
                  {CurrencyFormat(totalKewajiban + totalModal)}
                </span>
              </div>
            </u>
          </div>
          <br />
        </div>
      </div>
    </>
  );
}

CardTableNeraca.defaultProps = {
  color: "light",
};

CardTableNeraca.propTypes = {
  color: PropTypes.oneOf(["light", "dark"]),
};
